/**
 * Auth constants used by authentication services
 */

export const USER_AUTHORIZATION_KEY = 'https://deepcell.com/user_authorization'
export const ORG_ID_KEY = 'orgId'